/**
 * DO NOT EDIT DIRECTLY: Style Dictionary generated file.
 *
 * undefined vundefined
 */


export const COLOR_BORDER_BUTTON_OUTLINE  = "#ffffff";
export const COLOR_BORDER_BUTTON_SOLID  = "#ffffff";
export const COLOR_BORDER_BUTTON_BASE  = "#ffffff";
export const COLOR_BORDER_ENTRY_PREVIEW  = "#ffffff";
export const COLOR_BORDER_ENTRY_FORM_THUMBNAILS_BASE  = "#ffffff";
export const COLOR_BORDER_ENTRY_FORM_THUMBNAILS_SELECTED  = "#d2003c";
export const COLOR_BORDER_CROPPER_VIEW_BOX_BASE  = "#ffffff";
export const COLOR_BORDER_CROPPER_DASHED_BASE  = "#ffffff";
export const COLOR_BORDER_NINJA_FRAME_IMAGE_BASE  = "#ffffff";
export const COLOR_BORDER_PRIZE_CAROUSEL_IMAGE_BASE  = "#ffffff";
export const COLOR_BORDER_SUBMISSIONS_SECTION_THUMBNAIL_BASE  = "#ffffff";
export const COLOR_BORDER_SHARE_LINK_FORM_BASE  = "#797a7d";
export const COLOR_BORDER_SLIDER_INTERFACE_RANGE_TRACK  = "#ffffff";
export const COLOR_BORDER_SLIDER_INTERFACE_RANGE_THUMB  = "#f8d613";
export const COLOR_BORDER_SLIDER_INTERFACE_RANGE_THUMB_HOVER  = "#f8d613";
export const COLOR_BORDER_SLIDER_INTERFACE_RANGE_THUMB_PRESSED  = "#f8d613";
export const COLOR_CAROUSEL_INDICATOR_TEXT  = "#ffffff";
export const COLOR_DISCLAIMER_DISPLAY_TITLE_BASE  = "#ffffff";
export const COLOR_DISCLAIMER_DISPLAY_TITLE_SMALL  = "#ffffff";
export const COLOR_DISCLAIMER_DISPLAY_TITLE_LARGE  = "#ffffff";
export const COLOR_DISCLAIMER_DISPLAY_COPY_BASE  = "#d4d4d4";
export const COLOR_DISCLAIMER_DISPLAY_COPY_SMALL  = "#d4d4d4";
export const COLOR_DISCLAIMER_DISPLAY_COPY_LARGE  = "#d4d4d4";
export const COLOR_ENTRY_BASE  = "#e3e4e5";
export const COLOR_BACKGROUND_PAGE_ENTRY  = "#f8f8f8";
export const COLOR_BACKGROUND_PAGE_BASE  = "#000000";
export const COLOR_BACKGROUND_PAGE_NINJA  = "#000000";
export const COLOR_BACKGROUND_PAGE_MAIN  = "#000000";
export const COLOR_BACKGROUND_ENTRY_VIEW_BUTTON_BASE  = "#c6c6c7";
export const COLOR_BACKGROUND_ENTRY_VIEW_BUTTON_DISABLED  = "#e3e4e5";
export const COLOR_BACKGROUND_ENTRY_VIEW_BUTTON_HOVER  = "#adadad";
export const COLOR_BACKGROUND_ENTER_BUTTON_BASE  = "#c6c6c7";
export const COLOR_BACKGROUND_ENTER_BUTTON_DISABLED  = "#e3e4e5";
export const COLOR_BACKGROUND_ENTER_BUTTON_HOVER  = "#adadad";
export const COLOR_BACKGROUND_SUBMISSION_SHARE_BUTTON_BASE  = "#c6c6c7";
export const COLOR_BACKGROUND_SUBMISSION_SHARE_BUTTON_DISABLED  = "#e3e4e5";
export const COLOR_BACKGROUND_SUBMISSION_SHARE_BUTTON_HOVER  = "#adadad";
export const COLOR_BACKGROUND_ENTRY_FORM_THUMBNAILS_BASE  = "#141d3c";
export const COLOR_BACKGROUND_ENTRY_FORM_MESSAGE_BASE  = "#ffffff";
export const COLOR_BACKGROUND_ENTRY_SUCCESS_PREVIEW_BASE  = "#141d3c";
export const COLOR_BACKGROUND_CROPPER_MODAL_BASE  = "#e3e4e5";
export const COLOR_BACKGROUND_CROPPER_LINE_BASE  = "#000000";
export const COLOR_BACKGROUND_INFO_ICON_BASE  = "#ffffff";
export const COLOR_BACKGROUND_INFO_ICON_FOCUS  = "#ffffff";
export const COLOR_BACKGROUND_INFO_ICON_HOVER  = "#ffffff";
export const COLOR_BACKGROUND_NINJA_FRAME_TRANSITION  = "#f8d613";
export const COLOR_BACKGROUND_NINJA_LOADER  = "#000000";
export const COLOR_BACKGROUND_NINJA_LOADER_INITIAL  = "#000000";
export const COLOR_BACKGROUND_NINJA_LOADER_GRAPHIC  = "#f8d613";
export const COLOR_BACKGROUND_SHARE_LINK_FORM_BUTTON_BASE  = "#797a7d";
export const COLOR_BACKGROUND_SHARE_LINK_FORM_BUTTON_DISABLED  = "#e3e4e5";
export const COLOR_BACKGROUND_SHARE_LINK_FORM_BUTTON_HOVER  = "#adadad";
export const COLOR_BACKGROUND_SHARE_LINK_FORM_INPUT_BASE  = "#ffffff";
export const COLOR_BACKGROUND_SHARE_LINK_FORM_INPUT_DISABLED  = "#ffffff";
export const COLOR_BACKGROUND_SHARE_LINK_FORM_INPUT_HOVER  = "#ffffff";
export const COLOR_BACKGROUND_SLIDER_INTERFACE_RANGE_TRACK  = "#ffffff";
export const COLOR_BACKGROUND_SLIDER_INTERFACE_RANGE_THUMB  = "#f8d613";
export const COLOR_BACKGROUND_SLIDER_INTERFACE_RANGE_THUMB_HOVER  = "#f8d613";
export const COLOR_BACKGROUND_SLIDER_INTERFACE_RANGE_THUMB_PRESSED  = "#ffffff";
export const COLOR_BACKGROUND_SUBMISSION_LIGHTBOX  = "#000000";
export const COLOR_BACKGROUND_CLOSE_BUTTON  = "#000000";
export const COLOR_BACKGROUND_LIGHTBOX_BASE  = "#000000";
export const COLOR_BACKGROUND_BUTTON_PLAY_BUTTON  = "#ffffff";
export const COLOR_BACKGROUND_SUBMISSION_SUBMISSION_BASE  = "#121a35";
export const COLOR_BACKGROUND_SUBMISSION_MESSAGE_BASE  = "#121a35";
export const COLOR_BACKGROUND_SUBMISSION_FILL_BASE  = "#ffffff";
export const COLOR_TEXT_ENTRY_BASE  = "#000000";
export const COLOR_TEXT_UPLOAD_ICON  = "#e3e4e5";
export const COLOR_TEXT_FILE_UPLOAD_TEXT  = "#848484";
export const COLOR_TEXT_ENTRY_SUCCESS_MESSAGE_BASE  = "#d4d4d4";
export const COLOR_TEXT_INFO_ICON_BASE  = "#141d3c";
export const COLOR_TEXT_INFO_ICON_FOCUS  = "#141d3c";
export const COLOR_TEXT_INFO_ICON_HOVER  = "#141d3c";
export const COLOR_TEXT_BASE  = "#d4d4d4";
export const COLOR_TEXT_RED_BULL_H_1  = "#ffffff";
export const COLOR_TEXT_RED_BULL_H_2  = "#ffffff";
export const COLOR_TEXT_RED_BULL_H_3  = "#ffffff";
export const COLOR_TEXT_RED_BULL_BODY_COPY_REGULAR  = "#d4d4d4";
export const COLOR_TEXT_RED_BULL_EYEBROW_REGULAR  = "#d4d4d4";
export const COLOR_TEXT_RED_BULL_BODY_COPY_SMALL  = "#d4d4d4";
export const COLOR_TEXT_RED_BULL_BODY_COPY_FOOTNOTE  = "#d4d4d4";
export const COLOR_TEXT_SHARE_LINK_FORM_BUTTON_BASE  = "#ffffff";
export const COLOR_TEXT_SHARE_LINK_FORM_INPUT_BASE  = "#000000";
export const COLOR_TEXT_SUBMISSION_LIGHTBOX_REPORT  = "#ffffff";
export const COLOR_TEXT_SUBMISSION_LIGHTBOX_VIDEO_NOTE_LABEL  = "#ffffff";
export const COLOR_TEXT_SUBMISSION_MESSAGE  = "#ffffff";
export const COLOR_TEXT_HEADING  = "#ffffff";
export const COLOR_HERO_PLAY_PROGRESS  = "#f8d613";
export const COLOR_HERO_LOAD_PROGRESS  = "#ffffff";
export const COLOR_HERO_VIDEO_BORDER  = "#ffffff";
export const COLOR_INTERACTIVE_CAN_CALLOUT_LINE  = "#f8d613";
export const COLOR_INTERACTIVE_CAN_CALLOUT_TEXT  = "#ffffff";
export const COLOR_INTERACTIVE_CAN_SMALL_CALLOUT_TEXT_TEXT  = "#ffffff";
export const COLOR_RULES_DISPLAY_TITLE_BASE  = "#d4d4d4";
export const COLOR_RULES_DISPLAY_TITLE_SMALL  = "#d4d4d4";
export const COLOR_RULES_DISPLAY_TITLE_LARGE  = "#d4d4d4";
export const COLOR_RULES_DISPLAY_COPY_BASE  = "#d4d4d4";
export const COLOR_RULES_DISPLAY_COPY_SMALL  = "#d4d4d4";
export const COLOR_RULES_DISPLAY_COPY_LARGE  = "#d4d4d4";
export const COLOR_RULES_DISPLAY_CTA_BASE  = "#ffffff";
export const COLOR_RULES_DISPLAY_CTA_SMALL  = "#ffffff";
export const COLOR_RULES_DISPLAY_CTA_LARGE  = "#ffffff";
export const COLOR_TRADEMARK_DISPLAY_TITLE_BASE  = "#d4d4d4";
export const COLOR_TRADEMARK_DISPLAY_TITLE_SMALL  = "#d4d4d4";
export const COLOR_TRADEMARK_DISPLAY_TITLE_LARGE  = "#d4d4d4";
export const COLOR_TRADEMARK_DISPLAY_COPY_BASE  = "#d4d4d4";
export const COLOR_TRADEMARK_DISPLAY_COPY_SMALL  = "#d4d4d4";
export const COLOR_TRADEMARK_DISPLAY_COPY_LARGE  = "#d4d4d4";
export const COLOR_TRADEMARK_DISPLAY_CTA_BASE  = "#ffffff";
export const COLOR_TRADEMARK_DISPLAY_CTA_SMALL  = "#ffffff";
export const COLOR_TRADEMARK_DISPLAY_CTA_LARGE  = "#ffffff";
export const SIZE_BORDER_WIDTH_BUTTON_OUTLINE  = "0.1rem";
export const SIZE_BORDER_WIDTH_BUTTON_SOLID  = "0rem";
export const SIZE_BORDER_WIDTH_BUTTON_BASE  = "0rem";
export const SIZE_BORDER_WIDTH_HERO_VIDEO  = "0.1rem";
export const SIZE_BORDER_WIDTH_PRIZE_INDICATOR  = "0.1rem";
export const SIZE_BORDER_RADIUS_BUTTON_OUTLINE  = "0.4rem";
export const SIZE_BORDER_RADIUS_BUTTON_SOLID  = "0.4rem";
export const SIZE_BORDER_RADIUS_BUTTON_BASE  = "0.4rem";
export const SIZE_BORDER_RADIUS_ENTRY_PREVIEW  = "0.5rem";
export const SIZE_BORDER_RADIUS_ENTER_BUTTON  = "0.6rem";
export const SIZE_BORDER_RADIUS_ENTRY_FORM_THUMBNAILS_LARGE  = "0.4rem";
export const SIZE_BORDER_RADIUS_ENTRY_FORM_THUMBNAILS_SMALL  = "0.4rem";
export const SIZE_BORDER_RADIUS_HERO_VIDEO  = "0.8rem";
export const SIZE_BORDER_RADIUS_CROPPER_VIEW_BOX  = "0.5rem";
export const SIZE_BORDER_RADIUS_INFO_ICON_BASE  = "1.8rem";
export const SIZE_BORDER_RADIUS_NINJA_FRAME_IMAGE_BASE  = "0.5rem";
export const SIZE_BORDER_RADIUS_PRIZE_CAROUSEL_IMAGE_BASE  = "0.5rem";
export const SIZE_BORDER_RADIUS_PRIZE_INDICATOR  = "0.4rem";
export const SIZE_BORDER_RADIUS_SUBMISSIONS_SECTION_THUMBNAIL_SMALL  = "0.5rem";
export const SIZE_BORDER_RADIUS_SUBMISSIONS_SECTION_THUMBNAIL_BASE  = "0.5rem";
export const SIZE_BORDER_RADIUS_SUBMISSIONS_SECTION_THUMBNAIL_LARGE  = "0.5rem";
export const SIZE_BORDER_RADIUS_SHARE_LINK_FORM_BASE  = "0.6rem";
export const SIZE_BORDER_RADIUS_SHARE_LINK_FORM_SMALL  = "0.6rem";
export const SIZE_BORDER_RADIUS_SHARE_LINK_FORM_LARGE  = "0.6rem";
export const SIZE_BORDER_RADIUS_SUBMISSION  = "0.5rem";
export const SIZE_HEIGHT_BUTTON_OUTLINE  = "5rem";
export const SIZE_HEIGHT_BUTTON_SOLID  = "5rem";
export const SIZE_HEIGHT_BUTTON_BASE  = "5rem";
export const SIZE_HEIGHT_BUTTON_ICON  = "2rem";
export const SIZE_HEIGHT_PROGRESS_INDICATOR  = "0.1rem";
export const SIZE_HEIGHT_PROGRESS_INDICATOR_BUTTONS  = "3rem";
export const SIZE_HEIGHT_ENTRY_LOADER_LARGE  = "39.7rem";
export const SIZE_HEIGHT_ENTRY_LOADER_SMALL  = "39.7rem";
export const SIZE_HEIGHT_ENTRY_LOADER_TOP_SMALL  = "28.4rem";
export const SIZE_HEIGHT_ENTRY_LOADER_TOP_LARGE  = "28.4rem";
export const SIZE_HEIGHT_ENTRY_PREVIEW  = "39.8rem";
export const SIZE_HEIGHT_ENTER_BUTTON  = "6rem";
export const SIZE_HEIGHT_SUBMISSION_SHARE_BUTTON  = "2.8rem";
export const SIZE_HEIGHT_ENTRY_FORM_THUMBNAILS_LABEL_LARGE  = "2.6rem";
export const SIZE_HEIGHT_ENTRY_FORM_THUMBNAILS_LABEL_SMALL  = "2.6rem";
export const SIZE_HEIGHT_SOCIAL_ICON_CONTAINER  = "21.9rem";
export const SIZE_HEIGHT_SOCIAL_BAR  = "4.541rem";
export const SIZE_HEIGHT_SOCIAL_CALLOUT  = "4.2rem";
export const SIZE_HEIGHT_HERO_VIDEO_CLOSE_BUTTON  = "3rem";
export const SIZE_HEIGHT_HERO_VIDEO  = "74rem";
export const SIZE_HEIGHT_HERO_VIDEO_CONTROL_BAR  = "7rem";
export const SIZE_HEIGHT_HERO_VIDEO_CONTROL  = "4rem";
export const SIZE_HEIGHT_HERO_VIDEO_TIME_CONTROL  = "2.4rem";
export const SIZE_HEIGHT_HERO_SCROLL_LINE  = "10.7rem";
export const SIZE_HEIGHT_CAROUSEL_MIN_HEIGHT_BASE  = "67rem";
export const SIZE_HEIGHT_CAROUSEL_MIN_HEIGHT_SMALL  = "100rem";
export const SIZE_HEIGHT_HERO_SECTION_SMOKE_SMALL  = "15.72rem";
export const SIZE_HEIGHT_HERO_SECTION_SMOKE_LARGE  = "15.72rem";
export const SIZE_HEIGHT_IMAGE_SUBMISSION  = "39.8rem";
export const SIZE_HEIGHT_INFO_ICON_BASE  = "2.5rem";
export const SIZE_HEIGHT_INTERACTIVE_CAN_CALLOUT_TEXT  = "3.9rem";
export const SIZE_HEIGHT_INTERACTIVE_CAN_CALLOUT_POINTER  = "2rem";
export const SIZE_HEIGHT_INTERACTIVE_CAN_SMALL_CALLOUT_TEXT  = "4.4rem"; // Not spec'd this way but I want to leave room for wrapping (2 lines) without the height changing
export const SIZE_HEIGHT_INTERACTIVE_CAN_IMAGE_BASE  = "50.69rem";
export const SIZE_HEIGHT_INTERACTIVE_CAN_IMAGE_LARGE  = "50.69rem";
export const SIZE_HEIGHT_INTERACTIVE_CAN_IMAGE_SMALL  = "37rem";
export const SIZE_HEIGHT_PRIZE_INDICATOR  = "8.2rem";
export const SIZE_HEIGHT_PRIZE_LIST_SMALL  = "10rem"; // height required so that page height doesn't change when text does. May throw off vertical padding
export const SIZE_HEIGHT_RED_BULL_HEADER  = "8rem";
export const SIZE_HEIGHT_RED_BULL_HEADER_SMALL  = "6rem";
export const SIZE_HEIGHT_RULES_DISPLAY_BODY_COLLAPSIBLE_LARGE  = "7.2rem";
export const SIZE_HEIGHT_RULES_DISPLAY_BODY_COLLAPSIBLE_SMALL  = "5rem";
export const SIZE_HEIGHT_FINAL_CTA_SECTION_BASE  = "67.5rem";
export const SIZE_HEIGHT_FINAL_CTA_SECTION_SMALL  = "67.5rem";
export const SIZE_HEIGHT_FINAL_CTA_SECTION_LARGE  = "67.5rem";
export const SIZE_HEIGHT_FINAL_CTA_SECTION_COPY_BASE  = "9.4rem";
export const SIZE_HEIGHT_FINAL_CTA_SECTION_SMOKE_SMALL  = "24.14rem";
export const SIZE_HEIGHT_FINAL_CTA_SECTION_SMOKE_LARGE  = "24.14rem";
export const SIZE_HEIGHT_INTERACTIVE_CAN_SECTION_COPY  = "9.4rem";
export const SIZE_HEIGHT_INTERACTIVE_CAN_SECTION_SMALL  = "12.29rem";
export const SIZE_HEIGHT_INTERACTIVE_CAN_SECTION_LARGE  = "12.29rem";
export const SIZE_HEIGHT_INTERACTIVE_CAN_SMOKE_SMALL  = "29.25rem";
export const SIZE_HEIGHT_INTERACTIVE_CAN_SMOKE_LARGE  = "29.25rem";
export const SIZE_HEIGHT_PRIZES_SECTION_SMALL  = "65rem";
export const SIZE_HEIGHT_PRIZES_SECTION_LARGE  = "65rem";
export const SIZE_HEIGHT_SUBMISSIONS_SECTION_COPY_LARGE  = "NaNrem";
export const SIZE_HEIGHT_SUBMISSIONS_SECTION_COPY_SMALL  = "NaNrem";
export const SIZE_HEIGHT_SUBMISSIONS_SECTION_SMALL  = "61.9rem";
export const SIZE_HEIGHT_SUBMISSIONS_SECTION_LARGE  = "12.29rem";
export const SIZE_HEIGHT_SUBMISSIONS_SECTION_SMOKE_SMALL  = "17.738rem";
export const SIZE_HEIGHT_SUBMISSIONS_SECTION_SMOKE_LARGE  = "17.738rem";
export const SIZE_HEIGHT_SUBMISSIONS_SECTION_THUMBNAIL_SMALL  = "39.8rem";
export const SIZE_HEIGHT_SUBMISSIONS_SECTION_THUMBNAIL_BASE  = "39.8rem";
export const SIZE_HEIGHT_SUBMISSIONS_SECTION_THUMBNAIL_LARGE  = "39.8rem";
export const SIZE_HEIGHT_SHARE_LINK_FORM_BASE  = "3.5rem";
export const SIZE_HEIGHT_SHARE_LINK_FORM_SMALL  = "3.5rem";
export const SIZE_HEIGHT_SHARE_LINK_FORM_LARGE  = "3.5rem";
export const SIZE_HEIGHT_SLIDER_INTERFACE_LARGE  = "2.8rem";
export const SIZE_HEIGHT_SLIDER_INTERFACE_SMALL  = "2.8rem";
export const SIZE_HEIGHT_SLIDER_INTERFACE_RANGE_LARGE  = "0.1rem";
export const SIZE_HEIGHT_SLIDER_INTERFACE_RANGE_SMALL  = "0.1rem";
export const SIZE_HEIGHT_SLIDER_INTERFACE_RANGE_TRACK_LARGE  = "0.1rem";
export const SIZE_HEIGHT_SLIDER_INTERFACE_RANGE_TRACK_SMALL  = "0.1rem";
export const SIZE_HEIGHT_SLIDER_INTERFACE_RANGE_THUMB_LARGE  = "0.1rem";
export const SIZE_HEIGHT_SLIDER_INTERFACE_RANGE_THUMB_SMALL  = "0.1rem";
export const SIZE_HEIGHT_SLIDER_INTERFACE_RANGE_THUMB_HOVER_LARGE  = "0.3rem";
export const SIZE_HEIGHT_SLIDER_INTERFACE_RANGE_THUMB_HOVER_SMALL  = "0.3rem";
export const SIZE_HEIGHT_SLIDER_INTERFACE_RANGE_THUMB_PRESSED_LARGE  = "0.1rem";
export const SIZE_HEIGHT_SLIDER_INTERFACE_RANGE_THUMB_PRESSED_SMALL  = "0.1rem";
export const SIZE_HEIGHT_SLIDER_INTERFACE_BUTTON_LARGE  = "2.8rem";
export const SIZE_HEIGHT_SLIDER_INTERFACE_BUTTON_SMALL  = "2.8rem";
export const SIZE_HEIGHT_SUBMISSION_LIGHTBOX_DESIGN_ACCENT_SMALL  = "10rem";
export const SIZE_HEIGHT_SUBMISSION_LIGHTBOX_DESIGN_ACCENT_LARGE  = "12.5rem";
export const SIZE_HEIGHT_PLAY_BUTTON  = "6.3rem";
export const SIZE_HEIGHT_SECTION_SPACING_SECTION_LARGE  = "12rem";
export const SIZE_HEIGHT_SECTION_SPACING_SECTION_SMALL  = "12rem";
export const SIZE_HEIGHT_SECTION_SPACING_SECTION_BASE  = "12rem";
export const SIZE_HEIGHT_SLIDER_THUMB  = "5.5rem";
export const SIZE_HEIGHT_SLIDER_THUMB_INNER  = "1.3rem";
export const SIZE_HEIGHT_SLIDER  = "2.1rem";
export const SIZE_HEIGHT_PIECEWISE  = "0.3rem";
export const SIZE_HEIGHT_CAN_IMAGE  = "40rem";
export const SIZE_MARGIN_BUTTON_BASE  = "1.2rem";
export const SIZE_MARGIN_PROGRESS_INDICATOR  = "1rem";
export const SIZE_MARGIN_CAROUSEL_INDICATOR_COUNT  = "5rem";
export const SIZE_MARGIN_ENTRY_LOADER_TOP_SMALL  = "2.5rem";
export const SIZE_MARGIN_ENTRY_LOADER_TOP_LARGE  = "2.5rem";
export const SIZE_MARGIN_ENTRY_LOADER_BOTTOM_SMALL  = "8.1rem";
export const SIZE_MARGIN_ENTRY_LOADER_BOTTOM_LARGE  = "8.1rem";
export const SIZE_MARGIN_INSTRUCTIONS  = "1rem";
export const SIZE_MARGIN_RED_BULL_LOGO  = "2rem";
export const SIZE_MARGIN_BUTTON  = "1.4rem";
export const SIZE_MARGIN_SUBMISSION_SHARE_BUTTON_LEFT_RIGHT  = "1rem";
export const SIZE_MARGIN_SUCCESS_TITLE_TOP  = "2.9rem";
export const SIZE_MARGIN_SUCCESS_TITLE_BOTTOM  = "1.4rem";
export const SIZE_MARGIN_ENTRY_SUCCESS_PREVIEW_BOTTOM  = "2rem";
export const SIZE_MARGIN_ENTRY_SUCCESS_CHECKOUT_BOTTOM  = "1.5rem";
export const SIZE_MARGIN_INTERACTIVE_CAN_INFO_ICON  = "1rem";
export const SIZE_MARGIN_INTERACTIVE_CAN_SMALL_CALLOUT_TEXT  = "2.6rem";
export const SIZE_MARGIN_PRIZE_INDICATOR  = "4rem";
export const SIZE_MARGIN_PRIZE_TITLE  = "0.7rem";
export const SIZE_MARGIN_PRIZE_CAROUSEL_BUTTONS  = "-1.9rem";
export const SIZE_MARGIN_SUBMISSIONS_SECTION_THUMBNAIL_SMALL  = "3.3rem";
export const SIZE_MARGIN_SUBMISSIONS_SECTION_THUMBNAIL_BASE  = "3.3rem";
export const SIZE_MARGIN_SUBMISSIONS_SECTION_THUMBNAIL_LARGE  = "3.3rem";
export const SIZE_MARGIN_SHARE_LINK_FORM_RIGHT  = "0.5rem";
export const SIZE_MARGIN_SLIDER_INTERFACE_LARGE  = "0rem";
export const SIZE_MARGIN_SLIDER_INTERFACE_SMALL  = "0rem";
export const SIZE_MARGIN_SUBMISSION_LIGHTBOX_CONSTRAINT_SMALL  = "1.6rem";
export const SIZE_MARGIN_SUBMISSION_LIGHTBOX_CONSTRAINT_LARGE  = "5rem";
export const SIZE_MARGIN_SUBMISSION_LIGHTBOX_INCREMENT_BUTTON_SMALL  = "0rem";
export const SIZE_MARGIN_SUBMISSION_LIGHTBOX_INCREMENT_BUTTON_LARGE  = "7.8rem";
export const SIZE_MARGIN_SUBMISSION_LIGHTBOX_FOOTER_SMALL  = "5rem";
export const SIZE_MARGIN_SUBMISSION_LIGHTBOX_FOOTER_LARGE  = "5rem";
export const SIZE_MARGIN_VIDEO_LIGHTBOX_CONSTRAINT_SMALL  = "1.6rem";
export const SIZE_MARGIN_VIDEO_LIGHTBOX_CONSTRAINT_LARGE  = "6rem";
export const SIZE_MARGIN_RIGHT_BUTTON_COPY  = "0.5rem";
export const SIZE_MARGIN_RIGHT_HERO_VIDEO_CONTROL  = "1rem";
export const SIZE_MARGIN_RIGHT_HERO_VIDEO_FULLSCREEN_CONTROL  = "-0.5rem";
export const SIZE_MARGIN_RIGHT_HERO_BUTTON_SOLID_BASE  = "4rem";
export const SIZE_MARGIN_RIGHT_HERO_BUTTON_SOLID_MEDIUM  = "3rem";
export const SIZE_WIDTH_BUTTON_ICON  = "2rem";
export const SIZE_WIDTH_PROGRESS_INDICATOR  = "12.5rem";
export const SIZE_WIDTH_CAROUSEL_INDICATOR_NUMBER_SMALL  = "1.5rem";
export const SIZE_WIDTH_CAROUSEL_INDICATOR_NUMBER_LARGE  = "1.5rem";
export const SIZE_WIDTH_CAROUSEL_INDICATOR_NUMBER_BASE  = "1.5rem";
export const SIZE_WIDTH_ENTRY_LOADER_TOP_SMALL  = "28.4rem";
export const SIZE_WIDTH_ENTRY_LOADER_TOP_LARGE  = "28.4rem";
export const SIZE_WIDTH_ENTRY_PREVIEW  = "33.6rem";
export const SIZE_WIDTH_RED_BULL_LOGO  = "29.7rem";
export const SIZE_WIDTH_ENTER_BUTTON  = "51.3rem";
export const SIZE_WIDTH_SUBMISSION_SHARE_BUTTON  = "2.8rem";
export const SIZE_WIDTH_ENTRY_FORM_THUMBNAILS_LARGE  = "9.8rem";
export const SIZE_WIDTH_ENTRY_FORM_THUMBNAILS_SMALL  = "9.8rem";
export const SIZE_WIDTH_GRID_FULL_LARGE  = "144rem";
export const SIZE_WIDTH_GRID_FULL_MEDIUM  = "102.4rem";
export const SIZE_WIDTH_GRID_FULL_SMALL  = "37.5rem";
export const SIZE_WIDTH_GRID_FULL_BASE  = "144rem";
export const SIZE_WIDTH_GRID_CONTENT_AREA_X_LARGE  = "120rem";
export const SIZE_WIDTH_GRID_CONTENT_AREA_LARGE  = "110.4rem";
export const SIZE_WIDTH_GRID_CONTENT_AREA_MEDIUM  = "95rem";
export const SIZE_WIDTH_GRID_CONTENT_AREA_SMALL  = "34.4rem";
export const SIZE_WIDTH_GRID_CONTENT_AREA_BASE  = "120rem";
export const SIZE_WIDTH_GRID_COLUMN_LARGE  = "8.5rem";
export const SIZE_WIDTH_GRID_COLUMN_MEDIUM  = "6.5rem";
export const SIZE_WIDTH_GRID_COLUMN_SMALL  = "7.1rem";
export const SIZE_WIDTH_GRID_COLUMN_BASE  = "8.5rem";
export const SIZE_WIDTH_GRID_GUTTER_LARGE  = "1.6rem";
export const SIZE_WIDTH_GRID_GUTTER_MEDIUM  = "1.1rem";
export const SIZE_WIDTH_GRID_GUTTER_SMALL  = "2rem";
export const SIZE_WIDTH_GRID_GUTTER_BASE  = "1.6rem";
export const SIZE_WIDTH_GRID_ACCENT_LARGE  = "12rem";
export const SIZE_WIDTH_GRID_ACCENT_MEDIUM  = "6.2rem";
export const SIZE_WIDTH_GRID_ACCENT_SMALL  = "0rem";
export const SIZE_WIDTH_GRID_ACCENT_BASE  = "12rem";
export const SIZE_WIDTH_GRID_MARGIN_LARGE  = "12rem";
export const SIZE_WIDTH_GRID_MARGIN_MEDIUM  = "6.2rem";
export const SIZE_WIDTH_GRID_MARGIN_SMALL  = "1.6rem";
export const SIZE_WIDTH_GRID_MARGIN_BASE  = "12rem";
export const SIZE_WIDTH_SOCIAL_BAR  = "0.1rem";
export const SIZE_WIDTH_HERO_VIDEO_CLOSE_BUTTON  = "2.5rem";
export const SIZE_WIDTH_HERO_VIDEO  = "131.4rem";
export const SIZE_WIDTH_HERO_SCROLL_LINE  = "0.1rem";
export const SIZE_WIDTH_CONTENT_MIN_WIDTH  = "33.6rem";
export const SIZE_WIDTH_HERO_TITLE_MEDIUM  = "33.6rem";
export const SIZE_WIDTH_HERO_COPY_BASE  = "53.9rem";
export const SIZE_WIDTH_HERO_COPY_MEDIUM  = "30rem";
export const SIZE_WIDTH_HERO_COPY_SMALL  = "36rem";
export const SIZE_WIDTH_HERO_SECTION_SMOKE_SMALL  = "14.4rem";
export const SIZE_WIDTH_HERO_SECTION_SMOKE_LARGE  = "14.4rem";
export const SIZE_WIDTH_IMAGE_SUBMISSION  = "33.6rem";
export const SIZE_WIDTH_INFO_ICON_BASE  = "2.5rem";
export const SIZE_WIDTH_INTERACTIVE_CAN_CALLOUT_LINE  = "0.1rem";
export const SIZE_WIDTH_INTERACTIVE_CAN_CALLOUT_POINTER  = "2rem";
export const SIZE_WIDTH_INTERACTIVE_CAN_IMAGE_LARGE  = "18.8rem";
export const SIZE_WIDTH_INTERACTIVE_CAN_IMAGE_SMALL  = "13.1rem";
export const SIZE_WIDTH_PRIZE_INDICATOR  = "8.2rem";
export const SIZE_WIDTH_PRIZE_COPY  = "36.5rem";
export const SIZE_WIDTH_FINAL_CTA_SECTION_BASE  = "120rem";
export const SIZE_WIDTH_FINAL_CTA_SECTION_SMALL  = "120rem";
export const SIZE_WIDTH_FINAL_CTA_SECTION_LARGE  = "120rem";
export const SIZE_WIDTH_FINAL_CTA_SECTION_SMOKE_SMALL  = "144rem";
export const SIZE_WIDTH_FINAL_CTA_SECTION_SMOKE_LARGE  = "144rem";
export const SIZE_WIDTH_INTERACTIVE_CAN_SECTION_SMALL  = "14.4rem";
export const SIZE_WIDTH_INTERACTIVE_CAN_SECTION_LARGE  = "14.4rem";
export const SIZE_WIDTH_INTERACTIVE_CAN_SMOKE_SMALL  = "28.8rem";
export const SIZE_WIDTH_INTERACTIVE_CAN_SMOKE_LARGE  = "28.8rem";
export const SIZE_WIDTH_PRIZES_SECTION_SMALL  = "14.4rem";
export const SIZE_WIDTH_PRIZES_SECTION_LARGE  = "14.4rem";
export const SIZE_WIDTH_PRIZES_SECTION_COPY_SMALL  = "46.9rem";
export const SIZE_WIDTH_PRIZES_SECTION_COPY_LARGE  = "46.9rem";
export const SIZE_WIDTH_PRIZES_SECTION_LEFT_SMALL  = "69.1rem";
export const SIZE_WIDTH_PRIZES_SECTION_LEFT_LARGE  = "69.1rem";
export const SIZE_WIDTH_SUBMISSIONS_SECTION_SMALL  = "14.4rem";
export const SIZE_WIDTH_SUBMISSIONS_SECTION_LARGE  = "14.4rem";
export const SIZE_WIDTH_SUBMISSIONS_SECTION_SMOKE_SMALL  = "14.4rem";
export const SIZE_WIDTH_SUBMISSIONS_SECTION_SMOKE_LARGE  = "14.4rem";
export const SIZE_WIDTH_SUBMISSIONS_SECTION_THUMBNAIL_SMALL  = "33.6rem";
export const SIZE_WIDTH_SUBMISSIONS_SECTION_THUMBNAIL_BASE  = "33.6rem";
export const SIZE_WIDTH_SUBMISSIONS_SECTION_THUMBNAIL_LARGE  = "33.6rem";
export const SIZE_WIDTH_SHARE_LINK_FORM_BASE  = "43.9rem";
export const SIZE_WIDTH_SHARE_LINK_FORM_SMALL  = "43.9rem";
export const SIZE_WIDTH_SHARE_LINK_FORM_LARGE  = "43.9rem";
export const SIZE_WIDTH_SHARE_LINK_FORM_BUTTON_BASE  = "10.6rem";
export const SIZE_WIDTH_SHARE_LINK_FORM_BUTTON_SMALL  = "10.6rem";
export const SIZE_WIDTH_SHARE_LINK_FORM_BUTTON_LARGE  = "10.6rem";
export const SIZE_WIDTH_SLIDER_INTERFACE_LARGE  = "45.7rem";
export const SIZE_WIDTH_SLIDER_INTERFACE_SMALL  = "45.7rem";
export const SIZE_WIDTH_SLIDER_INTERFACE_RANGE_LARGE  = "41.2rem";
export const SIZE_WIDTH_SLIDER_INTERFACE_RANGE_SMALL  = "41.2rem";
export const SIZE_WIDTH_SLIDER_INTERFACE_RANGE_TRACK_LARGE  = "41.2rem";
export const SIZE_WIDTH_SLIDER_INTERFACE_RANGE_TRACK_SMALL  = "41.2rem";
export const SIZE_WIDTH_SLIDER_INTERFACE_RANGE_THUMB_LARGE  = "2.8rem";
export const SIZE_WIDTH_SLIDER_INTERFACE_RANGE_THUMB_SMALL  = "2.8rem";
export const SIZE_WIDTH_SLIDER_INTERFACE_RANGE_THUMB_HOVER_LARGE  = "2.8rem";
export const SIZE_WIDTH_SLIDER_INTERFACE_RANGE_THUMB_HOVER_SMALL  = "2.8rem";
export const SIZE_WIDTH_SLIDER_INTERFACE_RANGE_THUMB_PRESSED_LARGE  = "2.8rem";
export const SIZE_WIDTH_SLIDER_INTERFACE_RANGE_THUMB_PRESSED_SMALL  = "2.8rem";
export const SIZE_WIDTH_SLIDER_INTERFACE_BUTTON_LARGE  = "2.8rem"; // This is just an icon in zeplin.
export const SIZE_WIDTH_SLIDER_INTERFACE_BUTTON_SMALL  = "2.8rem";
export const SIZE_WIDTH_SUBMISSION_LIGHTBOX_DESIGN_ACCENT_SMALL  = "0rem"; // no controls on the side on small screens
export const SIZE_WIDTH_SUBMISSION_LIGHTBOX_DESIGN_ACCENT_LARGE  = "12.8rem"; // 78 + 50 (width of button)
export const SIZE_WIDTH_PLAY_BUTTON  = "6.3rem";
export const SIZE_WIDTH_SLIDER_THUMB  = "5.5rem";
export const SIZE_WIDTH_SLIDER_THUMB_INNER  = "1.3rem";
export const SIZE_WIDTH_SLIDER  = "45.7rem";
export const SIZE_WIDTH_PIECEWISE  = "0.3rem";
export const SIZE_TEXT_BUTTON_ICON  = "2rem";
export const SIZE_TEXT_CAROUSEL_INDICATOR_LABELS  = "1.2rem";
export const SIZE_TEXT_ENTRY_LOADER_SMALL  = "1.8rem";
export const SIZE_TEXT_ENTRY_LOADER_LARGE  = "1.8rem";
export const SIZE_TEXT_ENTRY_VIEW_BASE  = "1.2rem";
export const SIZE_TEXT_ENTRY_VIEW_BUTTON_SMALL  = "1.8rem";
export const SIZE_TEXT_ENTRY_VIEW_BUTTON_LARGE  = "1.8rem";
export const SIZE_TEXT_INFO_ICON_BASE  = "1.8rem";
export const SIZE_TEXT_INTERACTIVE_CAN_CALLOUT  = "1.8rem";
export const SIZE_TEXT_INTERACTIVE_CAN_SMALL_CALLOUT_TEXT  = "1.8rem";
export const SIZE_TEXT_BASE  = "8.2rem";
export const SIZE_TEXT_RED_BULL_H_1  = "8.2rem";
export const SIZE_TEXT_RED_BULL_H_2  = "6.2rem";
export const SIZE_TEXT_RED_BULL_H_3  = "4.2rem";
export const SIZE_TEXT_RED_BULL_BODY_COPY_REGULAR  = "1.8rem";
export const SIZE_TEXT_RED_BULL_EYEBROW_REGULAR  = "1.6rem";
export const SIZE_TEXT_RED_BULL_BODY_COPY_SMALL  = "1.6rem";
export const SIZE_TEXT_RED_BULL_BODY_COPY_FOOTNOTE  = "1.2rem";
export const SIZE_TEXT_MOBILE  = "4.8rem";
export const SIZE_TEXT_RED_BULL_H_1_MOBILE  = "4.8rem";
export const SIZE_TEXT_RED_BULL_H_2_MOBILE  = "4.8rem";
export const SIZE_TEXT_RED_BULL_H_3_MOBILE  = "1.8rem";
export const SIZE_TEXT_RED_BULL_BODY_COPY_SMALL_MOBILE  = "1.4rem";
export const SIZE_TEXT_RULES_DISPLAY_SMALL  = "1rem";
export const SIZE_TEXT_RULES_DISPLAY_LARGE  = "1.2rem";
export const SIZE_TEXT_RULES_DISPLAY_LARGE_SMALL  = "1rem";
export const SIZE_TEXT_RULES_DISPLAY_LARGE_LARGE  = "1.4rem";
export const SIZE_TEXT_SHARE_LINK_FORM_BASE  = "1.2rem";
export const SIZE_TEXT_SHARE_LINK_FORM_SMALL  = "1.2rem";
export const SIZE_TEXT_SHARE_LINK_FORM_LARGE  = "1.2rem";
export const SIZE_TEXT_SHARE_LINK_FORM_BUTTON_BASE  = "1.6rem";
export const SIZE_TEXT_SHARE_LINK_FORM_BUTTON_SMALL  = "1.6rem";
export const SIZE_TEXT_SHARE_LINK_FORM_BUTTON_LARGE  = "1.6rem";
export const SIZE_TEXT_SHARE_LINK_FORM_INPUT_BASE  = "1.2rem";
export const SIZE_TEXT_SHARE_LINK_FORM_INPUT_SMALL  = "1.2rem";
export const SIZE_TEXT_SHARE_LINK_FORM_INPUT_LARGE  = "1.2rem";
export const SIZE_TEXT_SUBMISSION_LIGHTBOX_REPORT  = "1.6rem";
export const SIZE_TEXT_PLAY_BUTTON  = "2.9rem";
export const SIZE_TEXT_TRADEMARK_DISPLAY_SMALL  = "1rem";
export const SIZE_TEXT_RED_BULL_BODY_COPY_X_SMALL  = "1.4rem"; // The old small values were updated to be larger in zeplin (?)
export const SIZE_PADDING_BUTTON_BASE  = "2rem";
export const SIZE_PADDING_ENTRY_VIEW_LARGE  = "1.6rem";
export const SIZE_PADDING_ENTRY_VIEW_MEDIUM  = "1.1rem";
export const SIZE_PADDING_ENTRY_VIEW_SMALL  = "2rem";
export const SIZE_PADDING_HERO_COPY_SMALL  = "0.5rem";
export const SIZE_PADDING_RULES_DISPLAY_HERO_LARGE  = "2.5rem";
export const SIZE_PADDING_RULES_DISPLAY_HERO_SMALL  = "0rem";
export const SIZE_PADDING_RULES_DISPLAY_COLLAPSIBLE_LARGE  = "0rem";
export const SIZE_PADDING_RULES_DISPLAY_COLLAPSIBLE_SMALL  = "3.6rem";
export const SIZE_PADDING_SHARE_LINK_FORM_INPUT_BASE  = "0.9rem";
export const SIZE_PADDING_SHARE_LINK_FORM_INPUT_SMALL  = "0.9rem";
export const SIZE_PADDING_SHARE_LINK_FORM_INPUT_LARGE  = "0.9rem";
export const SIZE_PADDING_TRADEMARK_DISPLAY_COLLAPSIBLE_LARGE  = "0rem";
export const SIZE_PADDING_TRADEMARK_DISPLAY_COLLAPSIBLE_SMALL  = "3.6rem";
export const SIZE_LINEHEIGHT_CAROUSEL_INDICATOR_LABELS  = "1.2rem";
export const SIZE_LINEHEIGHT_BASE  = "9rem";
export const SIZE_LINEHEIGHT_RED_BULL_H_1  = "9rem";
export const SIZE_LINEHEIGHT_RED_BULL_H_2  = "7rem";
export const SIZE_LINEHEIGHT_RED_BULL_H_3  = "4rem";
export const SIZE_LINEHEIGHT_RED_BULL_BODY_COPY_REGULAR  = "2.4rem";
export const SIZE_LINEHEIGHT_RED_BULL_EYEBROW_REGULAR  = "2.4rem";
export const SIZE_LINEHEIGHT_RED_BULL_BODY_COPY_SMALL  = "2.4rem";
export const SIZE_LINEHEIGHT_RED_BULL_BODY_COPY_FOOTNOTE  = "1.8rem";
export const SIZE_LINEHEIGHT_MOBILE  = "5.4rem";
export const SIZE_LINEHEIGHT_RED_BULL_H_1_MOBILE  = "5.4rem";
export const SIZE_LINEHEIGHT_RED_BULL_H_2_MOBILE  = "4.8rem";
export const SIZE_LINEHEIGHT_RED_BULL_H_3_MOBILE  = "2.8rem";
export const SIZE_LINEHEIGHT_RED_BULL_BODY_COPY_SMALL_MOBILE  = "1.8rem";
export const SIZE_LINEHEIGHT_RULES_DISPLAY_SMALL  = "1rem";
export const SIZE_LINEHEIGHT_RULES_DISPLAY_LARGE  = "1.8rem";
export const SIZE_LINEHEIGHT_RULES_DISPLAY_LARGE_SMALL  = "1rem";
export const SIZE_LINEHEIGHT_RULES_DISPLAY_LARGE_LARGE  = "2.4rem";
export const SIZE_LINEHEIGHT_SUBMISSION_LIGHTBOX_REPORT  = "2.4rem"; // 16 * 1.5
export const SIZE_LINEHEIGHT_RED_BULL_BODY_COPY_X_SMALL  = "1.8rem"; // The old small values were updated to be larger in zeplin (?)
export const SIZE_BORDER_ENTRY_LOADER_LOADER_SMALL  = "0.3rem";
export const SIZE_BORDER_ENTRY_LOADER_LOADER_LARGE  = "0.3rem";
export const SIZE_BORDER_ENTRY_PREVIEW  = "0.1rem";
export const SIZE_BORDER_ENTRY_FORM_THUMBNAILS_BASE  = "0.1rem";
export const SIZE_BORDER_ENTRY_FORM_THUMBNAILS_SELECTED  = "0.2rem";
export const SIZE_BORDER_CROPPER_VIEW_BOX  = "0.1rem";
export const SIZE_BORDER_NINJA_FRAME_IMAGE_BASE  = "0.1rem";
export const SIZE_BORDER_PRIZE_CAROUSEL_IMAGE_BASE  = "0.1rem";
export const SIZE_BORDER_SUBMISSIONS_SECTION_THUMBNAIL_SMALL  = "0.1rem";
export const SIZE_BORDER_SUBMISSIONS_SECTION_THUMBNAIL_BASE  = "0.1rem";
export const SIZE_BORDER_SUBMISSIONS_SECTION_THUMBNAIL_LARGE  = "0.1rem";
export const SIZE_BORDER_SHARE_LINK_FORM_BASE  = "0.1rem";
export const SIZE_BORDER_SHARE_LINK_FORM_SMALL  = "0.1rem";
export const SIZE_BORDER_SHARE_LINK_FORM_LARGE  = "0.1rem";
export const SIZE_BORDER_SLIDER_INTERFACE_RANGE_TRACK_LARGE  = "0.1rem";
export const SIZE_BORDER_SLIDER_INTERFACE_RANGE_TRACK_SMALL  = "0.1rem";
export const SIZE_BORDER_SLIDER_INTERFACE_RANGE_THUMB_LARGE  = "0.1rem";
export const SIZE_BORDER_SLIDER_INTERFACE_RANGE_THUMB_SMALL  = "0.1rem";
export const SIZE_BORDER_SLIDER_INTERFACE_RANGE_THUMB_HOVER_LARGE  = "0.3rem";
export const SIZE_BORDER_SLIDER_INTERFACE_RANGE_THUMB_HOVER_SMALL  = "0.3rem";
export const SIZE_BORDER_SLIDER_INTERFACE_RANGE_THUMB_PRESSED_LARGE  = "0.1rem";
export const SIZE_BORDER_SLIDER_INTERFACE_RANGE_THUMB_PRESSED_SMALL  = "0.1rem";
export const SIZE_BORDER_SUBMISSION  = "0.1rem";
export const SIZE_BORDER_GLOBAL_BASE  = "0.1rem";
export const SIZE_MAX_WIDTH_ENTRY_VIEW_LARGE  = "51.3rem";
export const SIZE_MAX_WIDTH_ENTRY_VIEW_SMALL  = "51.3rem";
export const SIZE_MAX_WIDTH_MEDIA_X_LARGE_BASE  = "0rem";
export const SIZE_MAX_WIDTH_MEDIA_LARGE_BASE  = "143.9rem";
export const SIZE_MAX_WIDTH_MEDIA_MEDIUM_HERO_OLD  = "105rem"; // Miles had this in as the medium breakpoint, but the layout actually changes at 600px
export const SIZE_MAX_WIDTH_MEDIA_MEDIUM_HERO  = "60rem"; // New hero breakpoint based on actual code left by Miles.
export const SIZE_MAX_WIDTH_MEDIA_MEDIUM_BASE  = "95rem";
export const SIZE_MAX_WIDTH_MEDIA_SMALL_BASE  = "59.9rem";
export const SIZE_MAX_WIDTH_HERO_SECTION_DISCLAIMER_SMALL  = "46.6rem";
export const SIZE_MAX_WIDTH_HERO_SECTION_DISCLAIMER_LARGE  = "46.6rem";
export const SIZE_MAX_WIDTH_PRIZE_CAROUSEL_CONTAINER_SMALL  = "50.8rem";
export const SIZE_MAX_WIDTH_PRIZE_CAROUSEL_CONTAINER_LARGE  = "50.8rem";
export const SIZE_MAX_WIDTH_RULES_DISPLAY_LARGE  = "46.6rem";
export const SIZE_MAX_WIDTH_RULES_DISPLAY_SMALL  = "30.6rem";
export const SIZE_MAX_WIDTH_FINAL_CTA_SECTION_DISCLAIMER_SMALL  = "70.7rem";
export const SIZE_MAX_WIDTH_FINAL_CTA_SECTION_DISCLAIMER_LARGE  = "70.7rem";
export const SIZE_MAX_WIDTH_SUBMISSIONS_SECTION_THUMBNAIL_BASE  = "32.2rem";
export const SIZE_MAX_WIDTH_SUBMISSIONS_SECTION_THUMBNAIL_LARGE  = "32.2rem";
export const SIZE_MAX_WIDTH_SUBMISSIONS_SECTION_THUMBNAIL_SMALL  = "32.2rem";
export const SIZE_MAX_WIDTH_SUBMISSIONS_SECTION_SMALL_GALLERY_SMALL  = "32.2rem";
export const SIZE_MAX_WIDTH_SUBMISSIONS_SECTION_SMALL_GALLERY_MEDIUM  = "55rem";
export const SIZE_MAX_WIDTH_SUBMISSIONS_SECTION_SMALL_GALLERY_LARGE  = "55rem";
export const SIZE_MAX_WIDTH_SUBMISSION_LIGHTBOX_WRAPPER_SMALL  = "74.3rem";
export const SIZE_MAX_WIDTH_SUBMISSION_LIGHTBOX_WRAPPER_LARGE  = "74.3rem";
export const SIZE_MAX_WIDTH_TRADEMARK_DISPLAY_LARGE  = "70.7rem";
export const SIZE_MAX_WIDTH_TRADEMARK_DISPLAY_SMALL  = "34.4rem";
export const SIZE_LINE_HEIGHT_BASE  = "2rem";
export const SIZE_FONT_SIZE_ENTER_BUTTON  = "1.8rem";
export const SIZE_FONT_SIZE_SUCCESS_TITLE  = "3.2rem";
export const SIZE_FONT_SIZE_CHECKOUT_LINK  = "1.6rem";
export const SIZE_LETTERSPACING_ENTER_BUTTON  = "0.1rem";
export const SIZE_LETTERSPACING_SUCCESS_TITLE  = "-0.128rem";
export const SIZE_LETTERSPACING_CHECKOUT_LINK  = "-0.061rem";
export const SIZE_LETTERSPACING_BASE  = "0rem";
export const SIZE_LETTERSPACING_RED_BULL_H_1  = "0rem";
export const SIZE_LETTERSPACING_RED_BULL_H_2  = "0rem";
export const SIZE_LETTERSPACING_RED_BULL_H_3  = "0rem";
export const SIZE_LETTERSPACING_RED_BULL_BODY_COPY_REGULAR  = "0rem";
export const SIZE_LETTERSPACING_RED_BULL_EYEBROW_REGULAR  = "0.6rem";
export const SIZE_LETTERSPACING_RED_BULL_BODY_COPY_SMALL  = "0rem";
export const SIZE_LETTERSPACING_RED_BULL_BODY_COPY_FOOTNOTE  = "0rem";
export const SIZE_LETTERSPACING_MOBILE  = "0rem";
export const SIZE_LETTERSPACING_RED_BULL_H_1_MOBILE  = "0rem";
export const SIZE_LETTERSPACING_RED_BULL_H_2_MOBILE  = "0rem";
export const SIZE_LETTERSPACING_RED_BULL_H_3_MOBILE  = "0rem";
export const SIZE_MARGIN_LEFT_ENTRY_FORM_THUMBNAILS_LARGE  = "1.6rem";
export const SIZE_MARGIN_LEFT_ENTRY_FORM_THUMBNAILS_MEDIUM  = "1.6rem";
export const SIZE_MARGIN_LEFT_ENTRY_FORM_THUMBNAILS_SMALL  = "1.6rem";
export const SIZE_MARGIN_LEFT_HERO_VIDEO_PLAY_CONTROL  = "-1rem";
export const SIZE_MIN_WIDTH_MEDIA_X_LARGE_BASE  = "144rem";
export const SIZE_MIN_WIDTH_MEDIA_LARGE_BASE  = "95rem";
export const SIZE_MIN_WIDTH_MEDIA_LARGE_PRIZES_SECTION  = "120rem";
export const SIZE_MIN_WIDTH_MEDIA_COUNTDOWN  = "96rem"; // just for the odd sizes where the coundown will wrap / unwrap
export const SIZE_MIN_WIDTH_MEDIA_MEDIUM_BASE  = "60rem";
export const SIZE_MIN_WIDTH_MEDIA_MEDIUM_HERO  = "60rem";
export const SIZE_MIN_WIDTH_MEDIA_SMALL_BASE  = "0rem";
export const SIZE_MIN_WIDTH_MEDIA_RED_BULL_HEADER_NAVIGATION  = "100rem"; // red bull media queries are mobile first
export const SIZE_MIN_WIDTH_MEDIA_RED_BULL_HEADER_LARGE  = "65rem"; // red bull media queries are mobile first
export const SIZE_MIN_WIDTH_SITE  = "30rem";
export const SIZE_MIN_WIDTH_SUBMISSIONS_SECTION_THUMBNAIL_BASE  = "20rem";
export const SIZE_MIN_WIDTH_SUBMISSIONS_SECTION_THUMBNAIL_LARGE  = "20rem";
export const SIZE_MIN_WIDTH_SUBMISSIONS_SECTION_THUMBNAIL_SMALL  = "20rem";
export const SIZE_MAX_HEIGHT_HERO_SECTION_SMALL  = "120rem";
export const SIZE_MAX_HEIGHT_HERO_SECTION_LARGE  = "120rem";
export const SIZE_MAX_HEIGHT_RULES_DISPLAY_BODY_COLLAPSIBLE_LARGE  = "7.2rem";
export const SIZE_MAX_HEIGHT_RULES_DISPLAY_BODY_COLLAPSIBLE_SMALL  = "7.2rem";
export const SIZE_MAX_HEIGHT_SUBMISSION_LIGHTBOX_WRAPPER_SMALL  = "92.3rem";
export const SIZE_MAX_HEIGHT_SUBMISSION_LIGHTBOX_WRAPPER_LARGE  = "92.3rem";
export const SIZE_MARGIN_BOTTOM_HERO_SCROLL_COPY  = "1.5rem";
export const SIZE_MARGIN_BOTTOM_HERO_EYEBROW_SMALL  = "2rem";
export const SIZE_MARGIN_BOTTOM_HERO_SECTION_SMALL  = "0rem";
export const SIZE_MARGIN_BOTTOM_HERO_SECTION_LARGE  = "0rem";
export const SIZE_MARGIN_BOTTOM_INTERACTIVE_CAN_CALLOUT_TEXT  = "0.6rem";
export const SIZE_MARGIN_BOTTOM_INTERACTIVE_CAN_SLIDER_SMALL  = "0rem";
export const SIZE_MARGIN_BOTTOM_INTERACTIVE_CAN_SLIDER_LARGE  = "0rem";
export const SIZE_MARGIN_BOTTOM_FINAL_CTA_SECTION_COPY_BASE  = "3.4rem"; // Not sure if this should be larger, based on zepplin this is the value and 9.4 will leave some space under the body text
export const SIZE_MARGIN_BOTTOM_FINAL_CTA_SECTION_COPY_LARGE  = "3.4rem"; // Not sure if this should be larger, based on zepplin this is the value and 9.4 will leave some space under the body text
export const SIZE_MARGIN_BOTTOM_FINAL_CTA_SECTION_SMALL  = "12rem";
export const SIZE_MARGIN_BOTTOM_FINAL_CTA_SECTION_LARGE  = "12rem";
export const SIZE_MARGIN_BOTTOM_INTERACTIVE_CAN_SECTION_CAN_SMALL  = "0rem";
export const SIZE_MARGIN_BOTTOM_INTERACTIVE_CAN_SECTION_CAN_LARGE  = "0rem";
export const SIZE_MARGIN_BOTTOM_INTERACTIVE_CAN_SECTION_COPY_SMALL  = "1.9rem";
export const SIZE_MARGIN_BOTTOM_INTERACTIVE_CAN_SECTION_COPY_LARGE  = "4.3rem"; // In zepplin it's 1.9 but there's an extra blank line in the text, so added 24px
export const SIZE_MARGIN_BOTTOM_INTERACTIVE_CAN_SECTION_SMALL  = "6.1rem";
export const SIZE_MARGIN_BOTTOM_INTERACTIVE_CAN_SECTION_LARGE  = "12rem * 2";
export const SIZE_MARGIN_BOTTOM_PRIZES_SECTION_SMALL  = "14rem";
export const SIZE_MARGIN_BOTTOM_PRIZES_SECTION_LARGE  = "12rem * 2";
export const SIZE_MARGIN_BOTTOM_PRIZES_SECTION_COPY_SMALL  = "3.72rem";
export const SIZE_MARGIN_BOTTOM_PRIZES_SECTION_COPY_LARGE  = "4.22rem";
export const SIZE_MARGIN_BOTTOM_SUBMISSIONS_SECTION_SMALL  = "12rem";
export const SIZE_MARGIN_BOTTOM_SUBMISSIONS_SECTION_LARGE  = "12rem";
export const SIZE_MARGIN_BOTTOM_SUBMISSIONS_SECTION_CAN_SMALL  = "3.61rem";
export const SIZE_MARGIN_BOTTOM_SUBMISSIONS_SECTION_CAN_LARGE  = "3.61rem";
export const SIZE_MARGIN_BOTTOM_SUBMISSIONS_SECTION_COPY_SMALL  = "3.6rem";
export const SIZE_MARGIN_BOTTOM_SUBMISSIONS_SECTION_COPY_LARGE  = "1.9rem";
export const SIZE_MARGIN_BOTTOM_SUBMISSIONS_SECTION_GRID_SMALL  = "7.4rem";
export const SIZE_MARGIN_BOTTOM_SUBMISSIONS_SECTION_GRID_BASE  = "7.4rem";
export const SIZE_MARGIN_BOTTOM_SUBMISSIONS_SECTION_GRID_LARGE  = "7.4rem";
export const SIZE_MARGIN_BOTTOM_SUBMISSION_LIGHTBOX_VIDEO_NOTE_SMALL  = "3.2rem";
export const SIZE_MARGIN_BOTTOM_SUBMISSION_LIGHTBOX_VIDEO_NOTE_LARGE  = "3.2rem";
export const SIZE_MARGIN_BOTTOM_SUBMISSION_LIGHTBOX_CONSTRAINT_SMALL  = "5rem";
export const SIZE_MARGIN_BOTTOM_SUBMISSION_LIGHTBOX_CONSTRAINT_LARGE  = "5rem";
export const SIZE_MARGIN_BOTTOM_SUBMISSION_MESSAGE  = "2.4rem";
export const SIZE_MARGIN_BOTTOM_VIDEO_LIGHTBOX_CONSTRAINT_SMALL  = "6rem";
export const SIZE_MARGIN_BOTTOM_VIDEO_LIGHTBOX_CONSTRAINT_LARGE  = "6rem";
export const SIZE_MARGIN_TOP_HERO_SCROLL_LINE  = "3rem";
export const SIZE_MARGIN_TOP_HERO_CAROUSEL_BUTTONS  = "2rem";
export const SIZE_MARGIN_TOP_HERO_COPY  = "2rem";
export const SIZE_MARGIN_TOP_HERO_SECTION_SMALL  = "0rem";
export const SIZE_MARGIN_TOP_HERO_SECTION_LARGE  = "0rem";
export const SIZE_MARGIN_TOP_HERO_SECTION_DISCLAIMER_SMALL  = "0rem";
export const SIZE_MARGIN_TOP_HERO_SECTION_DISCLAIMER_LARGE  = "5rem";
export const SIZE_MARGIN_TOP_INTERACTIVE_CAN_SLIDER_SMALL  = "3.6rem";
export const SIZE_MARGIN_TOP_INTERACTIVE_CAN_SLIDER_LARGE  = "3.6rem";
export const SIZE_MARGIN_TOP_PRIZE_CAROUSEL_CAROUSEL_INTERFACE_SMALL  = "6.4rem";
export const SIZE_MARGIN_TOP_PRIZE_CAROUSEL_CAROUSEL_INTERFACE_LARGE  = "0.5rem";
export const SIZE_MARGIN_TOP_PRIZE_CAROUSEL_PRIZE_LIST_SMALL  = "4.6rem";
export const SIZE_MARGIN_TOP_PRIZE_CAROUSEL_PRIZE_LIST_LARGE  = "0rem";
export const SIZE_MARGIN_TOP_FINAL_CTA_SECTION_COPY_BASE  = "3rem";
export const SIZE_MARGIN_TOP_FINAL_CTA_SECTION_SMALL  = "6rem";
export const SIZE_MARGIN_TOP_FINAL_CTA_SECTION_LARGE  = "6rem";
export const SIZE_MARGIN_TOP_FINAL_CTA_SECTION_DISCLAIMER_SMALL  = "3.9rem";
export const SIZE_MARGIN_TOP_FINAL_CTA_SECTION_DISCLAIMER_LARGE  = "3.9rem";
export const SIZE_MARGIN_TOP_INTERACTIVE_CAN_SECTION_COPY_SMALL  = "3.2rem";
export const SIZE_MARGIN_TOP_INTERACTIVE_CAN_SECTION_COPY_LARGE  = "3rem";
export const SIZE_MARGIN_TOP_INTERACTIVE_CAN_SECTION_CAN_SMALL  = "1.4rem";
export const SIZE_MARGIN_TOP_INTERACTIVE_CAN_SECTION_CAN_LARGE  = "1.9rem";
export const SIZE_MARGIN_TOP_INTERACTIVE_CAN_SECTION_SMALL  = "12rem";
export const SIZE_MARGIN_TOP_INTERACTIVE_CAN_SECTION_LARGE  = "12rem";
export const SIZE_MARGIN_TOP_PRIZES_SECTION_COPY_SMALL  = "3.1rem";
export const SIZE_MARGIN_TOP_PRIZES_SECTION_COPY_LARGE  = "2.4rem";
export const SIZE_MARGIN_TOP_PRIZES_SECTION_SMALL  = "6rem";
export const SIZE_MARGIN_TOP_PRIZES_SECTION_LARGE  = "0rem";
export const SIZE_MARGIN_TOP_SUBMISSIONS_SECTION_SMALL  = "6rem";
export const SIZE_MARGIN_TOP_SUBMISSIONS_SECTION_LARGE  = "12rem * 2";
export const SIZE_MARGIN_TOP_SUBMISSIONS_SECTION_COPY_SMALL  = "3.6rem";
export const SIZE_MARGIN_TOP_SUBMISSIONS_SECTION_COPY_LARGE  = "3rem";
export const SIZE_MARGIN_TOP_SUBMISSIONS_SECTION_CTA_SMALL  = "4.2rem";
export const SIZE_MARGIN_TOP_SUBMISSIONS_SECTION_CTA_LARGE  = "0rem";
export const SIZE_MARGIN_TOP_SUBMISSIONS_SECTION_GRID_SMALL  = "13rem";
export const SIZE_MARGIN_TOP_SUBMISSIONS_SECTION_GRID_BASE  = "13rem";
export const SIZE_MARGIN_TOP_SUBMISSIONS_SECTION_GRID_LARGE  = "13rem";
export const SIZE_MARGIN_TOP_SUBMISSIONS_SECTION_TRADEMARK_DISPLAY_SMALL  = "4.2rem";
export const SIZE_MARGIN_TOP_SUBMISSIONS_SECTION_TRADEMARK_DISPLAY_LARGE  = "7.4rem";
export const SIZE_MARGIN_TOP_SUBMISSION_LIGHTBOX_VIDEO_NOTE_SMALL  = "3.8rem";
export const SIZE_MARGIN_TOP_SUBMISSION_LIGHTBOX_VIDEO_NOTE_LARGE  = "3.8rem";
export const SIZE_MARGIN_TOP_SUBMISSION_LIGHTBOX_CONSTRAINT_SMALL  = "1.6rem";
export const SIZE_MARGIN_TOP_SUBMISSION_LIGHTBOX_CONSTRAINT_LARGE  = "0rem";
export const SIZE_MARGIN_TOP_VIDEO_LIGHTBOX_CONSTRAINT_SMALL  = "1.6rem";
export const SIZE_MARGIN_TOP_VIDEO_LIGHTBOX_CONSTRAINT_LARGE  = "1rem";
export const SIZE_MARGIN_TOP_SLIDER_THUMB  = "0.5rem";
export const SIZE_MARGIN_TOP_SLIDER  = "2rem";
export const SIZE_MARGIN_TOP_PIECEWISE  = "0.7rem";
export const SIZE_BOTTOM_HERO_VIDEO_PROGRESS_CONTROL  = "6rem";
export const SIZE_BOTTOM_HERO_SCROLL_CONTAINER_BASE  = "10rem";
export const SIZE_BOTTOM_HERO_SCROLL_CONTAINER_MEDIUM  = "-9rem";
export const SIZE_TRANSLATE_SOCIAL_CALLOUT_X  = "1rem";
export const SIZE_TRANSLATE_SOCIAL_CALLOUT_Y  = "1.3rem";
export const SIZE_RIGHT_SOCIAL_ICONS_BASE  = "0rem";
export const SIZE_RIGHT_SOCIAL_ICONS_MEDIUM_SCREEN  = "3rem";
export const SIZE_RIGHT_HERO_VIDEO_CLOSE_BUTTON  = "1rem";
export const SIZE_TOP_HERO_VIDEO_CLOSE_BUTTON  = "1rem";
export const SIZE_FONT_SIZE_HERO_VIDEO_CLOSE_BUTTON  = "3rem";
export const SIZE_FONT_SIZE_HERO_VIDEO_CONTROL  = "3.2rem";
export const SIZE_FONT_SIZE_PRIZE_INDICATOR  = "3.6rem";
export const SIZE_FONT_SIZE_PRIZE_TITLE  = "1.8rem";
export const SIZE_LINE_HEIGHT_HERO_VIDEO_CONTROL  = "3.2rem";
export const SIZE_LINE_HEIGHT_PRIZE_TITLE  = "2.4rem";
export const SIZE_BACKGROUND_POSITION_CAROUSEL_ONE  = "-6rem";
export const SIZE_BACKGROUND_POSITION_CAROUSEL_TWO  = "-4rem";
export const SIZE_MARGIN_TOP_RULES_DISPLAY_LARGE  = "5rem";
export const SIZE_MARGIN_TOP_RULES_DISPLAY_SMALL  = "1.5rem";
export const SIZE_SCREEN_EXTRA_LARGE  = "144rem";
export const SIZE_SCREEN_EXTRA_LARGE_PADDING  = "12rem";
export const SIZE_SCREEN_LARGE  = "110.4rem";
export const SIZE_SCREEN_LARGE_PADDING  = "6.2rem";
export const SIZE_PADDING_TOP_FINAL_CTA_SECTION_BASE  = "14rem";
export const SIZE_PADDING_TOP_FINAL_CTA_SECTION_SMALL  = "0rem";
export const SIZE_PADDING_TOP_FINAL_CTA_SECTION_LARGE  = "14rem";
export const SIZE_PADDING_TOP_INTERACTIVE_CAN_SECTION_SMALL  = "0rem";
export const SIZE_PADDING_TOP_INTERACTIVE_CAN_SECTION_LARGE  = "7.4rem";
export const SIZE_PADDING_TOP_PRIZES_SECTION_SMALL  = "6rem"; // spec'd at 16.4, splitting between padding and margin
export const SIZE_PADDING_TOP_PRIZES_SECTION_LARGE  = "12rem";
export const SIZE_PADDING_TOP_TERMS_CONDITIONS_VIEW_CONTENT_SMALL  = "8rem";
export const SIZE_PADDING_TOP_TERMS_CONDITIONS_VIEW_CONTENT_LARGE  = "8rem";
export const SIZE_PADDING_BOTTOM_FINAL_CTA_SECTION_BASE  = "14rem";
export const SIZE_PADDING_BOTTOM_FINAL_CTA_SECTION_SMALL  = "0rem";
export const SIZE_PADDING_BOTTOM_FINAL_CTA_SECTION_LARGE  = "14rem";
export const SIZE_PADDING_BOTTOM_INTERACTIVE_CAN_SECTION_SMALL  = "0rem";
export const SIZE_PADDING_BOTTOM_INTERACTIVE_CAN_SECTION_LARGE  = "7.4rem";
export const SIZE_PADDING_BOTTOM_PRIZES_SECTION_SMALL  = "0rem";
export const SIZE_PADDING_BOTTOM_PRIZES_SECTION_LARGE  = "0rem";
export const SIZE_PADDING_BOTTOM_TERMS_CONDITIONS_VIEW_CONTENT_SMALL  = "14.2rem";
export const SIZE_PADDING_BOTTOM_TERMS_CONDITIONS_VIEW_CONTENT_LARGE  = "14.2rem";
export const SIZE_PADDING_BOTTOM_TERMS_CONDITIONS_VIEW_TERMS_DISPLAY_SMALL  = "7.2rem";
export const SIZE_PADDING_BOTTOM_TERMS_CONDITIONS_VIEW_TERMS_DISPLAY_LARGE  = "7.2rem";
export const SIZE_MARGIN_OFFSET_SLIDER  = "1.5rem";
export const SIZE_BORDER_RADIUS_SLIDER_THUMB_INNER  = "0.65rem";
export const SIZE_BORDER_RADIUS_SLIDER  = "1.05rem";
export const SIZE_BORDER_WIDTH_SLIDER  = "0.1rem";
export const STYLE_BORDER_BUTTON_OUTLINE  = "solid";
export const STYLE_BORDER_BUTTON_SOLID  = "solid";
export const STYLE_BORDER_BUTTON_BASE  = "solid";
export const NUMBER_OPACITY_BUTTON_BASE  = 1;
export const NUMBER_OPACITY_BUTTON_DISABLED  = 0.26;
export const NUMBER_OPACITY_CROPPER_MODAL_BASE  = 0.6;
export const NUMBER_OPACITY_CROPPER_MODAL_MOVING  = 0.2;
export const NUMBER_OPACITY_CROPPER_POINT_BASE  = 0;
export const NUMBER_OPACITY_CROPPER_CENTER_BASE  = 0;
export const NUMBER_COUNT_GRID_COLUMNS_LARGE  = 12;
export const NUMBER_COUNT_GRID_COLUMNS_MEDIUM  = 12;
export const NUMBER_COUNT_GRID_COLUMNS_SMALL  = 4;
export const NUMBER_COUNT_GRID_COLUMNS_BASE  = 12;
export const NUMBER_UPLOAD_SIZE_LIMIT_RAW  = 200; // Max size in MB for an upload
export const NUMBER_UPLOAD_SIZE_LIMIT_COPY  = "200";
export const NUMBER_UPLOAD_DURATION_LIMIT_RAW  = 31; // 30 seconds limit for videos, padded because rounding is hard
export const NUMBER_UPLOAD_DURATION_LIMIT_COPY  = "30";
export const NUMBER_REM_SCALE_RAW  = 0.625;
export const NUMBER_HEIGHT_LIGHTBOX_MAX_RAW  = 0.8;
export const NUMBER_WIDTH_LIGHTBOX_MAX_RAW  = 0.8;
export const FONT_FAMILY_CAROUSEL_INDICATOR_LABELS  = "proxima-nova";
export const FONT_FAMILY_ENTRY_VIEW_BASE  = "futura-pt";
export const FONT_FAMILY_ENTRY_VIEW_MEDIUM  = "futura-pt";
export const FONT_FAMILY_ENTRY_VIEW_BOLD  = "futura-pt-bold";
export const FONT_FAMILY_UPLOAD  = "futura-pt";
export const FONT_FAMILY_CALLOUT  = "futura-pt-bold";
export const FONT_FAMILY_LIMIT_TERMS  = "futura-pt";
export const FONT_FAMILY_ENTRY_VIEW_THUMBNAILS  = "futura-pt";
export const FONT_FAMILY_INFO_ICON  = "proxima-nova";
export const FONT_FAMILY_INTERACTIVE_CAN_CALLOUT  = "ProximaNova";
export const FONT_FAMILY_INTERACTIVE_CAN_SMALL_CALLOUT_TEXT  = "proxima-nova";
export const FONT_FAMILY_PRIZE_TITLE  = "proxima-nova";
export const FONT_FAMILY_BASE  = "Anton";
export const FONT_FAMILY_RED_BULL_H_1  = "Anton";
export const FONT_FAMILY_RED_BULL_H_2  = "Anton";
export const FONT_FAMILY_RED_BULL_H_3  = "Anton";
export const FONT_FAMILY_RED_BULL_BODY_COPY_REGULAR  = "ProximaNova";
export const FONT_FAMILY_RED_BULL_EYEBROW_REGULAR  = "ProximaNova";
export const FONT_FAMILY_RED_BULL_BODY_COPY_SMALL  = "ProximaNova";
export const FONT_FAMILY_RED_BULL_BODY_COPY_FOOTNOTE  = "ProximaNova";
export const FONT_FAMILY_MOBILE  = "Anton";
export const FONT_FAMILY_RED_BULL_H_1_MOBILE  = "Anton";
export const FONT_FAMILY_RED_BULL_H_2_MOBILE  = "Anton";
export const FONT_FAMILY_RED_BULL_H_3_MOBILE  = "Anton";
export const FONT_FAMILY_BASE_FIXED  = "proxima-nova";
export const FONT_WEIGHT_DISCLAIMER_DISPLAY_TITLE_BASE  = "700";
export const FONT_WEIGHT_DISCLAIMER_DISPLAY_TITLE_SMALL  = "700";
export const FONT_WEIGHT_DISCLAIMER_DISPLAY_TITLE_LARGE  = "700";
export const FONT_WEIGHT_DISCLAIMER_DISPLAY_COPY_BASE  = "400";
export const FONT_WEIGHT_DISCLAIMER_DISPLAY_COPY_SMALL  = "400";
export const FONT_WEIGHT_DISCLAIMER_DISPLAY_COPY_LARGE  = "400";
export const FONT_WEIGHT_ENTER_BUTTON  = "600";
export const FONT_WEIGHT_INFO_ICON  = 700;
export const FONT_WEIGHT_INTERACTIVE_CAN_SMALL_CALLOUT_TEXT  = 700;
export const FONT_WEIGHT_PRIZE_TITLE  = 700;
export const FONT_WEIGHT_RED_BULL_H_1  = "400";
export const FONT_WEIGHT_RED_BULL_H_2  = "400";
export const FONT_WEIGHT_RED_BULL_H_3  = "400";
export const FONT_WEIGHT_RED_BULL_BODY_COPY_REGULAR  = "400";
export const FONT_WEIGHT_RED_BULL_EYEBROW_REGULAR  = "700";
export const FONT_WEIGHT_RED_BULL_BODY_COPY_SMALL  = "400";
export const FONT_WEIGHT_RED_BULL_BODY_COPY_FOOTNOTE  = "400";
export const FONT_WEIGHT_RED_BULL_H_1_MOBILE  = "400";
export const FONT_WEIGHT_RED_BULL_H_2_MOBILE  = "400";
export const FONT_WEIGHT_RED_BULL_H_3_MOBILE  = "400";
export const FONT_WEIGHT_RULES_DISPLAY_TITLE_BASE  = "700";
export const FONT_WEIGHT_RULES_DISPLAY_TITLE_SMALL  = "700";
export const FONT_WEIGHT_RULES_DISPLAY_TITLE_LARGE  = "700";
export const FONT_WEIGHT_RULES_DISPLAY_COPY_BASE  = "400";
export const FONT_WEIGHT_RULES_DISPLAY_COPY_SMALL  = "400";
export const FONT_WEIGHT_RULES_DISPLAY_COPY_LARGE  = "400";
export const FONT_WEIGHT_RULES_DISPLAY_CTA_BASE  = "400";
export const FONT_WEIGHT_RULES_DISPLAY_CTA_SMALL  = "400";
export const FONT_WEIGHT_RULES_DISPLAY_CTA_LARGE  = "400";
export const FONT_WEIGHT_SUBMISSION_LIGHTBOX_VIDEO_NOTE_LABEL  = 700;
export const FONT_STYLE_BASE  = "normal";
export const FONT_STYLE_RED_BULL_H_1  = "normal";
export const FONT_STYLE_RED_BULL_H_2  = "normal";
export const FONT_STYLE_RED_BULL_H_3  = "normal";
export const FONT_STYLE_RED_BULL_BODY_COPY_REGULAR  = "normal";
export const FONT_STYLE_RED_BULL_EYEBROW_REGULAR  = "normal";
export const FONT_STYLE_RED_BULL_BODY_COPY_SMALL  = "normal";
export const FONT_STYLE_RED_BULL_BODY_COPY_FOOTNOTE  = "normal";
export const FONT_STYLE_MOBILE  = "normal";
export const FONT_STYLE_RED_BULL_H_1_MOBILE  = "normal";
export const FONT_STYLE_RED_BULL_H_2_MOBILE  = "normal";
export const FONT_STYLE_RED_BULL_H_3_MOBILE  = "normal";
export const CONTENT_PROMPT_UPLOAD  = "Browse to upload photo or video…";
export const CONTENT_PROMPT_TYPE_INVALID  = "That file type won’t work here. Uploads must be: JPG, PNG, MP4, or MOV.";
export const CONTENT_PROMPT_SIZE_INVALID  = "Woah there! Your upload exceeds the 200MB limit. Please try again.";
export const CONTENT_PROMPT_DURATION_INVALID  = "That’s a lot of gaming. Please limit video submissions to 30 seconds or less.";
export const CONTENT_PROMPT_MODERATION_FAILED  = "Your entry has been flagged as something Ninja definitely doesn’t want to see. Please submit a photo or video showing what makes your game unique.";
export const CONTENT_PROMPT_TERMS_FAILED  = "You must accept terms";
export const CONTENT_PROMPT_VIDEO_ERROR  = "Can't open video";
export const CONTENT_PROMPT_UNKOWN  = "Something went wrong. Please try again.";
export const CONTENT_PROMPT_QUICKTIME_SUCCESS  = "Video ready!";
export const CONTENT_SUBMISSION_STATUS_PENDING_ENTRY  = "";
export const CONTENT_SUBMISSION_STATUS_PENDING_BASE  = "You’re too fast for us! This entry is still being processed, so check back soon.";
export const CONTENT_SUBMISSION_STATUS_LIVE_ENTRY  = "";
export const CONTENT_SUBMISSION_STATUS_LIVE_BASE  = "";
export const CONTENT_SUBMISSION_STATUS_FLAGGED_ENTRY  = "Your submission is pending review. Please check back later";
export const CONTENT_SUBMISSION_STATUS_FLAGGED_BASE  = "This entry is still being processed, so check back soon.";
export const CONTENT_SUBMISSION_STATUS_REPORTED_ENTRY  = "Your submission has been reported and is pending review. Please check back later";
export const CONTENT_SUBMISSION_STATUS_REPORTED_BASE  = "";
export const CONTENT_SUBMISSION_STATUS_APPROVED_ENTRY  = "";
export const CONTENT_SUBMISSION_STATUS_APPROVED_BASE  = "";
export const CONTENT_SUBMISSION_STATUS_REJECTED_ENTRY  = "Thank you for entering the contest. Unfortunately Red Bull has rejected your submission";
export const CONTENT_SUBMISSION_STATUS_REJECTED_BASE  = "This entry is not available, but you can still check out the rest of the submissions!";
export const CONTENT_SUBMISSION_ERROR_NOT_FOUND  = "This entry is not available, but you can still check out the rest of the submissions!"; // This is an error for a submission deep link. NOT a status
export const CONTENT_SUBMISSION_ERROR_LOAD_FAILURE  = "Can't load submission, try again later"; // This is an error for a submission expanded view where I can't load the submission for some reason _but_ I still managed to catch the error somehow. Again, NOT a status
export const CONTENT_BUTTON_ENTRY_VIEW_RESET  = "Try again";
export const CONTENT_BUTTON_ENTRY_VIEW_UPLOAD  = "Browse";
export const CONTENT_ENTRY_FORM_INSTRUCTIONS_CALLOUT  = "Show us your creativity, authenticity, and aesthetic";
export const CONTENT_ENTRY_FORM_INSTRUCTIONS_COPY  = "Uploads must be: JPG, PNG, MP4, or MOV. No larger than 200MB. Videos cannot exceed 30 seconds.";
export const CONTENT_ENTRY_FORM_RESET_CTA  = "Clear";
export const CONTENT_ENTRY_FORM_CONTINUE_CTA  = "Continue";
export const CONTENT_ENTRY_FORM_SUBMIT_CTA  = "Submit";
export const CONTENT_ENTRY_FORM_TERMS_COPY  = "I have read and agree to the contest ";
export const CONTENT_ENTRY_FORM_TERMS_CTA  = "Terms and Conditions";
export const CONTENT_ENTRY_FORM_CONSENT_NAME_COPY  = "I agree to my name being displayed with my entry.";
export const CONTENT_ENTRY_FORM_THUMBNAILS_COPY  = "Video Thumbnails";
export const CONTENT_ENTRY_FORM_INSTRUCTIONS_CROP  = "Position and crop your thumbnail";
export const CONTENT_ENTRY_FORM_CLOSE_TERMS_CTA  = "Back";
export const CONTENT_ENTRY_FORM_LOADER_COPY  = "Please wait while your submission is being processed.";
export const CONTENT_ENTRY_SUCCESS_HEADLINE_BASE  = " Success! Show off your entry on social.";
export const CONTENT_ENTRY_SUCCESS_HEADLINE_FLAGGED  = "Almost ready";
export const CONTENT_ENTRY_SUCCESS_HEADLINE_REJECTED  = "This entry didn’t make the cut";
export const CONTENT_ENTRY_SUCCESS_HEADLINE_REPORTED  = "This raised an eyebrow";
export const CONTENT_ENTRY_SUCCESS_BODY_BASE  = "It takes just a few minutes for your entry to be added to the site. Visit the link to check on the status.";
export const CONTENT_ENTRY_SUCCESS_BODY_FLAGGED  = "This entry is still being processed. Visit the link to check on the status.";
export const CONTENT_ENTRY_SUCCESS_BODY_REJECTED  = "Thanks for your interest in the contest. We cannot accept your entry, but you can still check out the rest of the submissions.";
export const CONTENT_ENTRY_SUCCESS_BODY_REPORTED  = "A member of the community asked us to take a second look at your entry.";
export const CONTENT_ENTRY_SUCCESS_CREDIT_COPY  = "Post submitted by";
export const CONTENT_ENTRY_SUCCESS_COPY_CTA  = "Copy";
export const CONTENT_ENTRY_SUCCESS_BACK_CTA  = "Back to site";
export const CONTENT_GENERAL_CRITERIA  = "Winners will be selected based on creativity (50%), authenticity (30%), and aesthetic (20%).";
export const CONTENT_GENERAL_ENTER_CTA  = "Enter Contest";
export const CONTENT_GENERAL_HEADLINE  = "Your chance to play with Ninja";
export const CONTENT_GENERAL_CREDIT_COPY  = "Post submitted by";
export const CONTENT_GENERAL_DISCLAIMER_TITLE  = "Disclaimer:";
export const CONTENT_GENERAL_RULES_TITLE  = "Disclaimer";
export const CONTENT_GENERAL_RULES_COPY  = "NO PURCHASE NECESSARY. THIS IS A SKILL CONTEST.  VOID WHERE PROHIBITED. Begins 4/1/19 at 12:01 am PST and ends 5/31/19 at 11:59 pm PST.  Open to legal US residents (incl. D.C.), 18+ and age of majority. ";
export const CONTENT_GENERAL_RULES_CTA  = "Official Rules.";
export const CONTENT_GENERAL_DISCLAIMER_COPY  = "Make sure not to use prominent brand marks or infringe on 3rd party rights.<br/>This will not bring you closer to winning!";
export const CONTENT_GENERAL_TWITTER_PREFIL_ENTRY_SUCCESS  = "Just submitted my chance to game with @Ninja IRL through @RedBull! 👀 my entry then upload your own";
export const CONTENT_GENERAL_TWITTER_PREFIL_BASE  = "";
export const CONTENT_GENERAL_SCREEN_NAME  = "RedBull";
export const CONTENT_GENERAL_HASHTAG  = "contest";
export const CONTENT_GENERAL_TRADEMARK_DISCLAIMER  = "All product and company names are trademarks™ or registered® trademarks of their respective holders. Display of the marks does not imply any affiliation with or sponsorship or endorsement by the trademark owners. The NINJA Logo and related designs are used under license. ";
export const CONTENT_SUBMISSION_SECTION_HEADLINE  = "See how they game";
export const CONTENT_SUBMISSION_SECTION_BODY  = "Check out all the entries right here, then submit your own.";
export const CONTENT_SUBMISSION_SECTION_LOAD_MORE_CTA  = "Load more";
export const CONTENT_SUBMISSION_SECTION_REPORT_ENTRY_CTA  = "Report entry";
export const CONTENT_SUBMISSION_SECTION_REPORT_SUCCESS  = "This submisson has been reported.<br />Thank you.";
export const CONTENT_SUBMISSION_SECTION_VIDEO_NOTE_LABEL  = "Note";
export const CONTENT_SUBMISSION_SECTION_VIDEO_NOTE  = "Video submissions will not have audio.";
export const CONTENT_HERO_EYEBROW  = "Red Bull Presents";
export const CONTENT_HERO_HEADLINE  = "Your chance to play with Ninja";
export const CONTENT_HERO_BODY_1  = "Show off how you play for a chance to win a meet and greet gaming session with Ninja. From your gaming space to your victory dance, get creative with your entry. ";
export const CONTENT_HERO_BODY_2  = "Winners will be selected based on creativity (50%), authenticity (30%), and aesthetic (20%). Go get that dub!";
export const CONTENT_HERO_FOLLOW_CTA  = "Follow";
export const CONTENT_HERO_WATCH_CTA  = "Watch Video";
export const CONTENT_HERO_ENTER_CTA  = "Enter Contest";
export const CONTENT_HERO_SCROLL_CTA_MOBILE  = "Tap";
export const CONTENT_HERO_SCROLL_CTA_BASE  = "Scroll";
export const CONTENT_CAN_SECTION_HEADLINE  = "Take the can for a spin";
export const CONTENT_CAN_SECTION_BODY  = "The wiiings you need, now with extra PonPon. Explore the Limited Edition Red Bull Ninja Can here, then head to your local retailer to stock up. Available in <span class=\"nowrap\">8.4oz</span> 4‑packs and 12‑packs for a limited time only.";
export const CONTENT_CAN_SECTION_CALLOUT_HEADBAND  = "Ninja x Red Bull Headband";
export const CONTENT_CAN_SECTION_CALLOUT_PON_PON  = "Ninja's Signature Dance";
export const CONTENT_CAN_SECTION_CALLOUT_LOGO  = "Ninja Logo";
export const CONTENT_CAN_SECTION_CALLOUT_SIGNATURE_STYLE  = "Ninja's Signature Style";
export const CONTENT_CAN_SECTION_CAN_IMAGE_ALT  = "Image of limited edition can";
export const CONTENT_FINAL_CTA_SECTION_HEADLINE  = "Your chance to play with Ninja";
export const CONTENT_FINAL_CTA_SECTION_BODY  = "Submit a photo or video (under 30 seconds) showing what makes your game unique. Winners will be selected based on creativity (50%), authenticity (30%), and aesthetic (20%). Let’s get it!";
export const CONTENT_PRIZE_SECTION_HEADLINE  = "Three prizes FTW";
export const CONTENT_PRIZE_SECTION_BODY  = "Step up your game for a chance at one of these prizes.";
export const CONTENT_PRIZE_SECTION_PRIZE_1_TITLE  = "Meet & Play with Ninja";
export const CONTENT_PRIZE_SECTION_PRIZE_1_BODY  = "The grand prize winner gets to hang with Ninja and a friend of their choice for an in-person gaming session at a Red Bull Event.";
export const CONTENT_PRIZE_SECTION_PRIZE_2_TITLE  = "NZXT H700i Ninja Edition PC + Official Game Play Headband of Ninja";
export const CONTENT_PRIZE_SECTION_PRIZE_2_BODY  = "2nd through 5th place winners will win a premium NINJA-branded NZXT Gaming PC, plus their own Official Game Play Headband of Ninja.";
export const CONTENT_PRIZE_SECTION_PRIZE_3_TITLE  = "NINJA‑branded backpack + Official Game Play Headband of Ninja";
export const CONTENT_PRIZE_SECTION_PRIZE_3_BODY  = "6th through 20th place winners get to take home their own NINJA-branded backpack and an Official Game Play Headband of Ninja.";
export const DURATION_SCROLL_HOME  = 400;
export const TIME_TRANSITION_NINJA_FRAME_TRANSITION_SLIDE  = 400;
export const TIME_TRANSITION_NINJA_FRAME_TRANSITION_DELAY  = 100;
export const TIME_TRANSITION_SLIDER_INTERFACE_RANGE_THUMB  = "200ms";
export const TIME_TRANSITION_GLOBAL_BASE  = "200ms";
export const TIME_TRANSITION_FADE_BASE  = "500ms";
export const TIME_GLOBAL_TRANSITION_BASE  = "200ms";
export const RATIO_WIDTH_IMAGE_SUBMISSION  = 33.6; // Value is in REM
export const RATIO_HEIGHT_IMAGE_SUBMISSION  = 39.8; // Value is in REM
export const SCREEN_QUERY_X_LARGE  = "1440px";
export const SCREEN_QUERY_LARGE  = "1439px";
export const SCREEN_QUERY_MEDIUM_BASE  = "950px";
export const SCREEN_QUERY_MEDIUM_HERO  = "1050px";
export const SCREEN_QUERY_SMALL  = "599px";
export const EASE_TRANSITION_SLIDER_INTERFACE_RANGE_THUMB  = "linear";